namespace TabAurous.Retail {
    export interface POSSalesGiftVoucherRow {
        TransGiftId?: number;
        TransId?: number;
        GiftMasterId?: number;
        UniqueCode?: string;
        Value?: number;
        Amount?: number;
        Expiry?: string;
        Quantity?: number;
        IsPartial?: boolean;
    }

    export namespace POSSalesGiftVoucherRow {
        export const idProperty = 'TransGiftId';
        export const nameProperty = 'UniqueCode';
        export const localTextPrefix = 'Retail.POSSalesGiftVoucher';
        export const deletePermission = 'Retail:POSSales:Delete';
        export const insertPermission = 'Retail:POSSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSSales:Edit';

        export declare const enum Fields {
            TransGiftId = "TransGiftId",
            TransId = "TransId",
            GiftMasterId = "GiftMasterId",
            UniqueCode = "UniqueCode",
            Value = "Value",
            Amount = "Amount",
            Expiry = "Expiry",
            Quantity = "Quantity",
            IsPartial = "IsPartial"
        }
    }
}
